export default __webpack_public_path__ + "static/media/pr_c_02.96f07006.jpg";